<p-dialog [header]="takeSurveyModalTitle" [modal]="true" [dismissableMask]="true" [(visible)]="isTakeSurveyModalVisible"
  [style]="{ width: '50%' }" [breakpoints]="{ '1400px': '50vw', '1200px': '75vw', '992px': '90vw' }">
  <ng-container *ngIf="isTakeSurveyFormSending">
    <div class="loading-cover">
      <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Sending
    </div>
  </ng-container>
  <ng-container *ngIf="!isTakeSurveyFormSending">
    <div class="card mb-3 shadow-sm">
      <div class="card-header bg-light">
        Survey Rating System
      </div>
      <div class="card-body">
        <table class="table table-sm mb-3">
          <thead>
            <tr>
              <th scope="col">Strongly Disagree</th>
              <th scope="col">Disagree</th>
              <th scope="col">Somewhat Agree / Disagree</th>
              <th scope="col">Agree</th>
              <th scope="col">Strongly Agree</th>
              <th scope="col">No Answer / Does Not Apply</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>5</td>
              <td>N</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ng-container *ngIf="!isTakeSurveyFormLoaded">
      <div class="loading-cover">
        <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
      </div>
    </ng-container>
    <ng-container *ngIf="isTakeSurveyFormLoaded">
      <form [formGroup]="surveyForm" (ngSubmit)="submitSurveyForm()">
        <div class="col mb-3">
          <label class="form-label" for="surveyAttorney"><strong>Attorney</strong></label>
          <select id="surveyAttorney" class="form-select form-select-sm" formControlName="surveyAttorney" data-private
            [class.is-invalid]="surveyForm.get('surveyAttorney')?.invalid && surveyForm.get('surveyAttorney')?.touched"
            [compareWith]="compareAttorneys">
            <option [ngValue]="null" disabled>Select an Attorney</option>
            <option *ngFor="let attorney of surveyAttorneys" [ngValue]="attorney">
              {{ attorney.name }}
            </option>
          </select>
          <div *ngIf="surveyForm.get('surveyAttorney')?.invalid && surveyForm.get('surveyAttorney')?.touched"
            class="invalid-feedback">
            <div *ngIf="surveyForm.get('surveyAttorney')?.errors?.['required']">Attorney is required.</div>
          </div>
        </div>
        <div *ngFor="let question of surveyQuestions">
          <input type="hidden" [id]="'responseid_' + question.surveyQuestionId!.toString()"
            [formControlName]="'responseid_' + question.surveyQuestionId!.toString()" [value]="" />
          <div class="col mb-3" *ngIf="question.type === 'B'">
            <label class="w-100 mb-2" data-private><strong>{{ question.text }}</strong></label>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="true"> Yes
            </div>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="false"> No
            </div>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="'NA'"> No Answer
            </div>
            <div class="row">
              <div class="col mb-3">
                <label class="w-100 mb-2 sr-only"><strong>Comments</strong></label>
                <textarea class="form-control" placeholder="Enter comments here"
                  [id]="question.surveyQuestionId!.toString() + '_comments'" rows="3"
                  [formControlName]="question.surveyQuestionId!.toString() + '_comments'" data-private></textarea>
              </div>
            </div>
          </div>
          <div class="col mb-3" *ngIf="question.type === 'R'">
            <label class="w-100 mb-2"><strong>{{ question.text }}</strong></label>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="1"> 1
            </div>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="2"> 2
            </div>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="3"> 3
            </div>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="4"> 4
            </div>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="5"> 5
            </div>
            <div class="form-check form-check-inline" data-private>
              <input type="radio" class="form-check-input" [formControlName]="question.surveyQuestionId!.toString()"
                [value]="0"> N
            </div>
            <div class="row">
              <div class="col mb-3">
                <label class="w-100 mb-2 sr-only"><strong>Comments</strong></label>
                <textarea class="form-control" placeholder="Enter comments here"
                  [id]="question.surveyQuestionId!.toString() + '_comments'" rows="3"
                  [formControlName]="question.surveyQuestionId!.toString() + '_comments'" data-private></textarea>
              </div>
            </div>
          </div>

          <div *ngIf="question.type === 'T'">
            <label class="w-100 mb-2"><strong>{{ question.text }}</strong></label>
            <textarea class="form-control" id="notes" rows="3" [formControlName]="question.surveyQuestionId!.toString()"
              data-private></textarea>
          </div>
        </div>

        <div class="flex justify-content-end gap-2 mt-3">
          <button class="btn btn-sm btn-link" type="button" (click)="toggleTakeSurveyModal()">Cancel</button>
          <button class="btn btn-sm btn-primary" type="submit"
            [disabled]="surveyForm.invalid">{{submitSurveyButtonText}}</button>
        </div>
      </form>
    </ng-container>
  </ng-container>



</p-dialog>